import {
  CONFIRMED_CREATE_PATIENT_MALE_CHART,
  CONFIRMED_DELETE_PATIENT_MALE_CHART,
  CONFIRMED_EDIT_PATIENT_MALE_CHART,
  CONFIRMED_GET_PATIENT_MALE_CHARTS,
} from "./PatientMalechartType"

import {
  createPatientMaleChart,
  deletePatientMaleChart,
  updatePatientMaleChart,
  getPatientMaleChart,
  formatPatientMaleChart,
} from "../../services/PatientMalechartService"

import swal from "sweetalert"
import { showErrorAlert } from "../../services/ErrorHandlingService"

// Token util
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey
  if (stateToken) return stateToken

  const storedUser = localStorage.getItem("userDetails")
  return storedUser ? JSON.parse(storedUser).token : null
}

// Get all patient male chart entries
export function getPatientMaleChartAction(chartData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState)

      console.log("Patient Male Chart Data to fetch:", chartData)

      const requestData = {
        patient_id: chartData.patient_id,
      }

      console.log("Final request data:", requestData)

      const response = await getPatientMaleChart(requestData.patient_id)
      console.log("API raw response:", response)

      if (response?.data?.status === "success") {
        const data = response.data.data
        const formattedData = Array.isArray(data)
          ? data.map((chart) => formatPatientMaleChart(chart))
          : formatPatientMaleChart(data)

        console.log("Formatted Patient Male Charts:", formattedData)

        dispatch({
          type: CONFIRMED_GET_PATIENT_MALE_CHARTS,
          payload: formattedData,
        })

        return formattedData
      } else {
        const errorMessage = response?.data?.message || "Failed to fetch patient male charts"
        showErrorAlert(errorMessage, "error")
        return []
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch patient male charts"

      console.error("Patient Male Chart Fetch Error:", error.response?.data || error.message)
      showErrorAlert(errorMessage, "error")
      return []
    }
  }
}

// CREATE Patient Male Chart
export function createPatientMaleChartAction(chartData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState)

      // Process symptoms - extract values from selected options
      let symptomArray = []
      if (chartData.symptoms && Array.isArray(chartData.symptoms)) {
        symptomArray = chartData.symptoms.map((option) => option.value)
      }

      // Handle "Other" symptom
      let other_name = ""
      const otherIndex = symptomArray.indexOf("Other")
      if (otherIndex !== -1) {
        other_name = chartData.otherSymptom || ""
        symptomArray.splice(otherIndex, 1)
      }

      // Convert symptoms array to JSON string for server
      const symptom_intercourse = JSON.stringify(symptomArray)

      // Process metallic color - extract value from selected option (single selection)
      let metalic_color = ""
      if (chartData.metallicColor) {
        if (typeof chartData.metallicColor === "object" && chartData.metallicColor.value) {
          metalic_color = chartData.metallicColor.value
        } else if (typeof chartData.metallicColor === "string") {
          metalic_color = chartData.metallicColor
        }
      }

      // Prepare the request payload - send symptom_intercourse as JSON string
      const requestData = {
        patient_id: chartData.patient_id,
        malechart_date: chartData.date,
        symptom_intercourse: symptom_intercourse,
        metalic_color: metalic_color,
        other_name: other_name,
        by_patient: chartData.by_patient,
      }

      console.log("Create request data:", requestData)
      console.log("symptom_intercourse JSON string:", symptom_intercourse)

      const response = await createPatientMaleChart(requestData)

      if (response?.data?.status === "success") {
        const formattedData = formatPatientMaleChart(response.data.data)

        dispatch({
          type: CONFIRMED_CREATE_PATIENT_MALE_CHART,
          payload: formattedData,
        })

        return { success: true, data: formattedData }
      }

      const errorMessage = response?.data?.message || "Failed to create chart"
      throw new Error(errorMessage)
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to create chart"
      throw error
    }
  }
}

// UPDATE Patient Male Chart
export function updatePatientMaleChartAction(chartData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState)

      // Process symptoms - extract values from selected options
      let symptomArray = []
      if (chartData.symptoms && Array.isArray(chartData.symptoms)) {
        symptomArray = chartData.symptoms.map((option) => option.value)
      }

      // Handle "Other" symptom
      let other_name = ""
      const otherIndex = symptomArray.indexOf("Other")
      if (otherIndex !== -1) {
        other_name = chartData.otherSymptom || ""
        symptomArray.splice(otherIndex, 1)
      }

      // Convert symptoms array to JSON string for server
      const symptom_intercourse = JSON.stringify(symptomArray)

      // Process metallic color - extract value from selected option (single selection)
      let metalic_color = ""
      if (chartData.metallicColor) {
        if (typeof chartData.metallicColor === "object" && chartData.metallicColor.value) {
          metalic_color = chartData.metallicColor.value
        } else if (typeof chartData.metallicColor === "string") {
          metalic_color = chartData.metallicColor
        }
      }

      const requestData = {
        patient_id: chartData.patient_id,
        male_chart_id: chartData.chart_id,
        malechart_date: chartData.date,
        symptom_intercourse: symptom_intercourse,
        metalic_color: metalic_color,
        other_name: other_name,
      }

      console.log("Update request data:", requestData)
      console.log("symptom_intercourse JSON string:", symptom_intercourse)

      const response = await updatePatientMaleChart(requestData)

      if (response?.data?.status === "success") {
        const formattedData = formatPatientMaleChart(response.data.data)

        dispatch({
          type: CONFIRMED_EDIT_PATIENT_MALE_CHART,
          payload: formattedData,
        })

        return { success: true, data: formattedData }
      }

      const errorMessage = response?.data?.message || "Failed to update chart"
      throw new Error(errorMessage)
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update chart"
      throw error
    }
  }
}

// Delete Patient Male Chart
export function deletePatientMaleChartAction(chartData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState)

      console.log("Patient Male Chart Data to delete:", chartData)

      const requestData = {
        patient_id: chartData.patient_id,
        male_chart_id: chartData.chart_id,
      }

      console.log("Final request data:", requestData)

      const response = await deletePatientMaleChart(requestData)
      console.log("API raw response:", response)

      if (response?.data?.status === "success") {
        const payload = {
          chart_id: chartData.chart_id,
          message: response.data.message || "Chart deleted successfully",
        }

        dispatch({
          type: CONFIRMED_DELETE_PATIENT_MALE_CHART,
          payload,
        })

        return { success: true, data: payload }
      }

      const errorMessage = response?.data?.message || "Unexpected response format"
      throw new Error(errorMessage)
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to delete patient male chart"

      console.error("Patient Male Chart Delete Error:", error.response?.data || error.message)
      throw error
    }
  }
}
